import ConsentNotificationModal from './ConsentNotificationModal.container';
export default ConsentNotificationModal;